import React from 'react';

import { Icon } from '../icons';

export const UnsplashIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M21.9313501,14.1693364 L32,14.1693364 L32,32 L-1.84741111e-13,32 L-1.84741111e-13,14.1693364 L10.0686499,14.1693364 L10.0686499,23.0663616 L21.8947368,23.0663616 L21.8947368,14.1693364 L21.9313501,14.1693364 Z M21.9313501,-1.0658141e-14 L21.8947368,-1.0658141e-14 L21.8947368,8.93363844 L10.0686499,8.93363844 L10.0686499,-1.0658141e-14 L21.9313501,-1.0658141e-14 Z" />
    </svg>
  );
};
